import { lazy } from 'react';
import { Routes } from './utils/renderRoutes';

const accountRoutes: Routes[] = [
    {
        title: '客户账户',
        path: '/customer-account',
        component: lazy(() => import('@/views/CustomerAccount')),
        children: [
            {
                title: '客户账户',
                path: '/customer-account/list',
                component: lazy(() => import('@/views/CustomerAccount/List')),
            },
            {
                title: '创建会员',
                path: '/customer-account/member/create',
                component: lazy(() => import('@/views/CustomerAccount/Member')),
            },
            {
                title: '会员详情',
                path: '/customer-account/member/detail/:id',
                component: lazy(() => import('@/views/CustomerAccount/Member')),
            },
            {
                title: '创建非会员',
                path: '/customer-account/no-member/create',
                component: lazy(() => import('@/views/CustomerAccount/NotMember')),
            },
            {
                title: '非会员详情',
                path: '/customer-account/no-member/detail/:id',
                component: lazy(() => import('@/views/CustomerAccount/NotMember')),
            },
            {
                title: '快捷服务',
                path: '/customer-account/quick',
                component: lazy(() => import('@/views/CustomerAccount/QuickService')),
                children: [
                    {
                        title: '快捷服务-优惠停车',
                        path: '/customer-account/quick/parking',
                        component: lazy(() => import('@/views/CustomerAccount/QuickService/Parking')),
                    },
                ]
            },
            {
                redirect: true,
                from: '/customer-account',
                to: '/customer-account/list',
            },
        ],
    },
];
export default accountRoutes;